window.addEventListener("DOMContentLoaded", () => {
  // Legacy initialization for the original ingredients-wide section
  const section = document.querySelector(
    ".tvg_ingredients_wide_tLvyYW_IngredientsWide.tvg_ingredients_wide_tLvyYW_IngredientsWide__content-bottom"
  );
  initModal(section);

  // Get all sections with modals in them
  const modalSections = document.querySelectorAll('.js-init-modal');

  if (modalSections) {
    modalSections.forEach((modalSection) => initModal(modalSection));
  }

  function initModal(modalSection) {
    if (!modalSection) {
      return;
    }

    const modal = modalSection.querySelector(".js-modal");
    const modalOverlay = modalSection.querySelector(".js-modal-overlay");
    const trigger = modalSection.querySelector(".js-modal-trigger");
    const close = modalSection.querySelector(".js-modal-close");
    if (modal && modalOverlay && trigger && close) {
      trigger.addEventListener("click", () => {
        modal.classList.add("modal-open");
        modalOverlay.classList.add("overlay-open");
      });

      close.addEventListener("click", () => {
        modal.classList.remove("modal-open");
        modalOverlay.classList.remove("overlay-open");
      });

      modalOverlay.addEventListener("click", () => {
        modal.classList.remove("modal-open");
        modalOverlay.classList.remove("overlay-open");
      });
    }
  }
});
